const initialState = {
    data: [],
  };
  
  const wspolnotaWazneNumeryUReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_WSPOLNOTA_WAZNE_NUMERY':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default wspolnotaWazneNumeryUReducer;